"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackCustomEvent = trackCustomEvent;
exports.trackSidevisning = trackSidevisning;
exports.trackUtgaaendeLenke = trackUtgaaendeLenke;
exports.useMatomo = void 0;
var _react = require("react");
var _MatomoContext = require("./MatomoContext");
var _types = require("./types");
var _MatomoConfig = require("./MatomoConfig");
const useMatomo = () => {
  const {
    instans
  } = (0, _react.useContext)(_MatomoContext.MatomoContext);
  if (!instans) {
    throw new Error('Mangler matomo-instans.. Har du husket MatomoContext.Provider?');
  }
  return {
    leggTilInstruksjon: _MatomoConfig.leggTilInstruksjon,
    trackSidevisning,
    trackUtgaaendeLenke,
    trackCustomEvent
  };
};
exports.useMatomo = useMatomo;
function trackSidevisning(tittel) {
  (0, _MatomoConfig.leggTilInstruksjon)('setCustomUrl', window.location.href);
  (0, _MatomoConfig.leggTilInstruksjon)('setDocumentTitle', tittel);
  (0, _MatomoConfig.leggTilInstruksjon)(_types.TRACK_TYPER.PAGE_VIEW);
}
function trackUtgaaendeLenke(url) {
  (0, _MatomoConfig.leggTilInstruksjon)('trackLink', url, 'link');
}
function trackCustomEvent(kategori, handling, navn, verdi) {
  if (!verdi) {
    (0, _MatomoConfig.leggTilInstruksjon)('trackEvent', kategori, handling, navn);
    return;
  }
  (0, _MatomoConfig.leggTilInstruksjon)('trackEvent', kategori, handling, navn, verdi);
}